import { render, staticRenderFns } from "./detailShows.vue?vue&type=template&id=30e56d96&scoped=true&"
import script from "./detailShows.vue?vue&type=script&lang=js&"
export * from "./detailShows.vue?vue&type=script&lang=js&"
import style0 from "./detailShows.vue?vue&type=style&index=0&id=30e56d96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e56d96",
  null
  
)

export default component.exports